import { IRangeDates } from '@/fsd/shared/ui/month-range-picker-with-options/model/types/IRangeDates';
import cx from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import styles from './month-range-picker-with-options.module.scss';
import MonthRangePickerCurrentYearOption from './ui/MonthRangePickerCurrentYearOption/MonthRangePickerCurrentYearOption';
import MonthRangePickerCustomPeriodOption from './ui/MonthRangePickerCustomPeriodOption/MonthRangePickerCustomPeriodOption';
import MonthRangePickerPrevYearOption from './ui/MonthRangePickerPrevYearOption/MonthRangePickerPrevYearOption';

export interface IMonthRangePickerWithOptionsProps {
  selectedOption?: number;
  setSelectedOption: Dispatch<
    SetStateAction<IMonthRangePickerWithOptionsProps['selectedOption']>
  >;
  setShowOptions: Dispatch<SetStateAction<boolean>>;
  setDates: (dates: IRangeDates) => void;
  className?: string;
}

const MonthRangePickerWithOptions = ({
  selectedOption,
  setSelectedOption,
  setShowOptions,
  setDates,
  className,
}: IMonthRangePickerWithOptionsProps) => {
  const getOptionsClassnames = (index: number) => {
    return cx(
      styles.option,
      index === selectedOption ? styles.active : undefined
    );
  };

  return (
    <div className={cx(styles.options, className)}>
      <MonthRangePickerCurrentYearOption
        selectedOption={selectedOption}
        setDates={setDates}
        setSelectedOption={setSelectedOption}
        setShowOptions={setShowOptions}
        getOptionsClassnames={getOptionsClassnames}
      />
      <MonthRangePickerPrevYearOption
        selectedOption={selectedOption}
        setDates={setDates}
        setSelectedOption={setSelectedOption}
        setShowOptions={setShowOptions}
        getOptionsClassnames={getOptionsClassnames}
      />
      <MonthRangePickerCustomPeriodOption
        selectedOption={selectedOption}
        setDates={setDates}
        setSelectedOption={setSelectedOption}
        setShowOptions={setShowOptions}
        getOptionsClassnames={getOptionsClassnames}
      />
    </div>
  );
};

export default MonthRangePickerWithOptions;
